<template>
    <div id="app" :class="domaineSlug+' '+brandedApp">

        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="fullPage"></loading>

        <div class="container-planning" style="position: relative">
            <b-row>
                <b-col cols="12" sm="12" md="3" lg="3" xl="3" >
                    <b-dropdown class="langueSelect" :text="langs[$i18n.locale]">
                        <b-dropdown-item v-for="(lang, i) in langs" v-bind:data="$i18n.locale" v-bind:key="i" style="display: inline" @click="$i18n.locale = i; configdateTimePicker.locale = i;"><img width="15px" :src="'https://www.doinsport.club/assets/flags/'+i+'.png'" /> {{ lang }}</b-dropdown-item>
                    </b-dropdown>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="6" xl="6">
                    <label class="text-center">{{ $t('select_date_title') }}</label>
                    <flat-pickr id="datepicker" :config="configdateTimePicker" v-model="date" @on-change="emitOnChange" />
                </b-col>
                <b-col cols="12" sm="12" md="3" lg="3" xl="3">
                    <div v-if="user == null">
                        <button v-if="user == null"  class="btn-user" @click="openConnexion()"><user-icon size="3x" class="custom-class"></user-icon></button>
                    </div>
                    <div v-if="user != null">
                        <label class="text-center">{{ user.firstName }} {{ user.lastName }}</label>
                        <img class="avatar avatar-lg " v-bind:src="'https://api.doinsport.club/'+user.avatar" v-if="user.avatar != ''" />
                        <img class="avatar avatar-lg " src="../../public/img/avatar_default.png" v-if='user != null && user.avatar === ""' />
                    </div>
                    <div >
                        <label v-for="(credit, index) in myCredits" v-if="credit != undefined" class="text-center">{{ credit.libelle }}:  {{ credit.value }}</label>
                    </div>
                    <div v-if="myAbonnement != null">
                        <label class="text-center">{{ $t('label_your_abonnement') }}:  {{ myAbonnement }}</label>
                    </div>
                </b-col>
            </b-row>

            <div style="margin-top: 45px;">
                <div v-if="domaineSlug == 'lamaisondusquash'">
                    <ul>
                        <li><label class="badge-hp">Créneau en heure pleine</label></li>
                        <li><label class="badge-hc">Créneau en heure creuse</label></li>
                    </ul>
                </div>
                <b-tabs content-class="mt-3" align="center" fill>
                    <b-tab :title="$t('slot_available')" active>
                        <div class="block">
                            <div class="sport-choices" v-for="(sport, i) in sports" v-if="sports.length > 1" >
                                <button v-if="i === sportSelected" @click="updateSport(null)" class="sportSelected">{{ sport }}</button>
                                <button v-if="i !== sportSelected" @click="updateSport(i)">{{ sport }}</button>
                            </div>

                            <div class="block">
                                <div class="playground-choices">
                                    <div class="playground" style="display: inline-flex; flex-direction: column;" v-for="(playground, indexP) in playgrounds" v-if="(sportSelected == playground.sportId) || (sportSelected == null)">
                                        <h3 style="order:0">{{ playground.playground_name }}</h3>

                                        <button v-if="playground.is_activity" :class="'btn-slot btn-slot-activity '+slot.type" v-for="(slot, indexS) in playground.activitiesSlot" @click="getFormActivitySlot(playground.data.playground_id, slot)" :style="'order: ' + moment(slot.start).unix() + '; -webkit-order:: ' + moment(slot.start).unix() + ';'" >
                                            <strong>{{ moment(slot.start.date).format('H:mm') }}</strong><br>
                                            <small>{{ slot.available }} places disponibles</small>
                                        </button>

                                        <button v-if="!playground.is_activity && indexS < limitRow || showAll" :class="'btn-slot '+slot.type" v-for="(slot, indexS) in playground.data.slots" @click="selectSlot (playground.data.playground_id, indexS)" :style="'order: ' + moment(slot.startTime).unix() + '; -webkit-order:: ' + moment(slot.startTime).unix() + ';'" >{{ moment(slot.startTime).format("H:mm") }}</button>
                                        <button v-if="!playground.is_activity && domaineSlug == 'lamaisondusquash'" :class="'btn-booking '" v-for="(booking, indexB) in playground.data.bookings" :style="'order: ' + moment(booking.startTime).unix() + '; -webkit-order:: ' + moment(booking.startTime).unix() + ';'">{{ moment(booking.startTime).format('H:mm') }} {{ booking.name }}</button>
                                    </div>
                                </div>
                                <button class="showallBooking" v-on:click="showAllAction()" v-if="showAll === false && this.domaineSlug != 'lamaisondusquash'">{{ $t('all_slots') }}..</button>
                            </div>
                        </div>
                    </b-tab>
                    <b-tab :title="$t('my_bookings')" v-if="user !== null">
                        <h3>{{ $t('bookings_list') }}</h3>
                        <b-row>
                            <b-col cols="4" v-for="(booking, indexB) in bookings">
                                <b-card class="bookingCard" >
                                    <h4>{{ booking.node.name }}</h4>
                                    <label>{{ $t('playground') }} : {{ booking.node.playground.name }}</label>
                                    <label>{{ $t('date') }} : {{ moment(booking.node.fromClient).format('D/MM/Y') }}</label>
                                    <label>{{ $t('horaire') }} : {{ moment(booking.node.fromClient).format('HH:mm') }} - {{ moment(booking.node.toClient).format('H:mm') }}</label>
                                    <button class="cancel" v-on:click="cancelBooking(booking.node.id)" v-if="showAll === false">{{ $t('cancel') }}</button>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('logout')" v-if="user !== null" @click="logout()"></b-tab>
                </b-tabs>
            </div>

        </div>

        <div class="block-center" v-if="showActivityForm === true && user !== null">
            <div class="modalblock" >
                <h3 style="font-weight: 900;">Réserver votre activité {{ formActivity.name }}</h3>

                <form-activity @cancel="showActivityForm = false" :items="formActivity.items" :slotActivity="selectedActivitySlot" :date="date" ></form-activity>

            </div>
        </div>

        <div class="block-center" v-if="modalConnexion === true">
            <div class="modalblock" >
                <h3 style="font-weight: 900;">{{ $t('connexion') }}</h3>

                <div class="block">
                    <label>{{ $t('tape_phone_number') }}</label>
                </div>
                <div class="block">
                    <div style="width: 100%; max-width: 500px; margin: 20px auto; height: 80px;">
                    <vue-tel-input class="phone-input" v-model="phoneNumber" v-bind="bindProps"></vue-tel-input>
                    </div>
                </div>
                <div class="block"  v-if="tapeCode === false">
                    <button @click="connexion()" class="confirm" style="width: 100%" >{{ $t('send_code') }}</button>
                    <button class="btn-create" @click="modalSignup = true;" style="width: 100%" >{{ $t('create_account') }}</button>
                </div>

                <div class="block" v-if="tapeCode === true">
                    <label>{{ $t('tape_sms_code') }}</label>
                </div>
                <div class="block" v-if="tapeCode === true">
                    <div style="width: 500px; margin: 20px auto; height: 80px;">
                        <Sms v-model="code" v-bind="inputCode"></Sms>
                    </div>
                </div>
                <div class="block">
                    <button @click="validCodeSms()" v-if="tapeCode === true" class="confirm" style="width: 100%" >{{ $t('validate') }}</button>
                </div>
                <div class="block">
                    <button @click="cancelConnexion()" class="cancel" style="width: 100%" >{{ $t('cancel') }}</button>
                </div>
            </div>
        </div>

        <div class="block-center" v-if="modalSignup === true">

            <div class="modalblock" v-if="modalPhone === true" >
                <b-row style="position: relative">
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" >
                        <h3 style="font-weight: 900;">{{ $t('create_account') }}</h3>
                    </b-col>
                </b-row>

                <b-row style="position: relative" v-if="modalSignupStep1 === true">

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" >
                        <div style="width: 500px; margin: 20px auto; height: 80px;">
                            <label>{{ $t('tape_phone_number') }}</label>
                            <vue-tel-input class="phone-input" v-model="phoneNumberSignup" v-bind="bindProps"></vue-tel-input>
                        </div>
                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="tapeCodesignup === true">
                        <label>{{ $t('tape_sms_code') }}</label>
                        <div style="width: 500px; margin: 20px auto; height: 80px;">
                            <Sms v-model="code" v-bind="inputCodeSignup"></Sms>
                        </div>
                    </b-col>

                    <b-col cols="12" class="mt-4" v-if="tapeCodesignup === false" >
                        <button @click="createNewAccount() " class="confirm" style="width: 100%" >{{ $t('send_code') }}</button>
                    </b-col>
                    <b-col cols="12" class="mt-4" v-if="tapeCodesignup === true">
                        <button @click="validCodeSmsSignUp()" v-if="tapeCodesignup === true" class="confirm" style="width: 100%" >{{ $t('validate') }}</button>
                    </b-col>
                    <b-col cols="12" class="mt-4" >
                        <button @click="modalSignup = false" class="cancel" style="width: 100%" >{{ $t('cancel') }}</button>
                    </b-col>

                </b-row>

                <b-row style="position: relative" v-if="modalSignupStep2 === true">
                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" >
                        <label>{{ $t('your_first_name') }}</label>
                        <b-form-input class="phone-input" v-model="firstNameUser"></b-form-input>
                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" >
                        <label>{{ $t('your_last_name') }}</label>
                        <b-form-input class="phone-input" v-model="lastNameUser"></b-form-input>
                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" >
                        <label>{{ $t('your_email') }}</label>
                        <b-form-input class="phone-input" v-model="emailUser"></b-form-input>
                    </b-col>

                    <b-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="tapeCodesignup === true" style="margin-top: 20px">
                        <button @click="cancelConnexion()" class="cancel" >{{ $t('cancel') }}</button>
                        <button @click="createAccount()" v-if="tapeCodesignup === true" class="confirm" >{{ $t('validateAccount') }}</button>
                    </b-col>
                </b-row>
            </div>
        </div>

        <div class="block-center" v-if="slotSelected !== null && modalConnexion === false && user !== null">
            <div class="modalblock" >
                <h3>{{ $t('your_selection') }}</h3>

                <div class="block">
                    <label><b>{{ $t('playground') }}</b> : {{ slotSelected.playground_name }} </label>
                    <div style="width: 55%; display: inline-block;">
                        <label><b>{{ $t('date') }}</b> : {{ moment(slotSelected.startTime).format('D/MM/Y') }} </label>
                    </div>
                    <div style="width: 40%; display: inline-block;">
                        <h1 style="display: inline-block;">{{ moment(slotSelected.startTime).format('H:mm') }} - {{ moment(slotSelected.endTime).format('H:mm') }}</h1>
                    </div>
                </div>

                <div class="block" v-if="domaineSlug != 'lamaisondusquash'">
                    <label>
                        {{ $t('tape_booking_name') }}
                    </label>
                    <input name="name" class="name-booking" v-model="bookingName" :placeholder="$t('name_booking')" />
                </div>

                <div class="block" v-if="domaineSlug == 'lamaisondusquash'">
                    <label>
                        {{ $t('add_booking_attender') }}
                    </label>
                    <input name="name" class="name-booking" v-model="attenderName" :placeholder="$t('attender_booking')" />
                </div>

                <div class="block">
                    <label>
                        {{ $t('select_duration') }}
                    </label>

                    <select class="selectDuration" v-model="selectedDurationM" @change="updateEndSlot()" required :disabled="selectReadonly">
                        <option v-for="(price, duration) in slotDurations" :value="duration" :key="duration">{{ duration }} {{ $t('minutes') }}</option>
                    </select>

                </div>

                <div class="block" v-if="options.length > 0" >
                    <label>
                        {{ $t('select_option') }} :
                    </label>

                    <div class="custom-control custom-checkbox form-check-inline"

                         v-for="(option, id) in options"
                    >
                        <input :id="option.id"
                               :value="option.id"
                               class="custom-control-input"
                               type="checkbox"
                               v-model="optionsSelected"
                               v-on:change="updatePriceOption(option)"
                               :disabled="(selectReadonly && !inArray(option.id, optionsSelected)) || (!inArrayDuration(option.duration, slotDurations) && option.fix)"
                        />
                        <label :for="option.id" class="custom-control-label">
                            <slot>
                                <span v-if="option.price" >&nbsp{{ option.label }} (+{{ option.price }} {{devise}})</span>
                                <span v-else="option.price" >&nbsp{{ option.label }} </span>
                                &nbsp;&nbsp;&nbsp;<i class="fa fa-info-circle" v-on:click="showInfo(option.description)"></i>
                            </slot>
                        </label>
                    </div>

                </div>

                <div class="block" v-if="priceSelected !== null">
                    <h2>{{ priceSelected }} {{devise}}</h2>
                </div>

                <div class="block">
                    <button @click="cancelSlot()" class="cancel" >{{ $t('cancel') }}</button>

                    <button v-if="getCreditByDuration() <= checkCreditAvailable(slotSelected)" @click="confirmBooking(true)" class="confirm-credit" >{{ $t('validate_credit') }} : {{ getCreditByDuration() }}</button>

                    <button @click="confirmBooking()" class="confirm" >{{ $t('validate') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import moment from 'moment'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { UserIcon } from 'vue-feather-icons'
    import clubService from '@/services/ClubService.js'
    import userService from '@/services/UserService.js'
    import bookingService from '@/services/BookingService.js'
    import playgroundService from '@/services/PlaygroundService.js'

    import Sms from 'ofcold-security-code';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BModal, VBModal, BCard, BDropdown, BDropdownItem, BCol, BFormInput, BFormSelect } from 'bootstrap-vue';
    import BaseCheckbox from "../components/BaseCheckbox.vue";
    import Icon from "../components/Icon.vue";
    import FormActivity from "../components/FormActivity.vue";

    import FrenchLocal from 'flatpickr/dist/l10n/fr.js';
    import NlLocal from 'flatpickr/dist/l10n/nl.js';

    var sha1 = require('sha1');
    var md5 = require('js-md5');

    export default {
        name: 'home',
        data () {
            return {
                devise: '€',
                showActivityForm: false,
                formActivity: null,
                myCredits: [],
                typeCredit: null,
                myAbonnement: null,
                isBookingFree: false,
                limitRow: 500,
                brandedApp: 'doinsport',
                selectReadonly: false,
                modalSignupStep1: true,
                modalSignupStep2: false,
                langueSelected: null,
                firstNameUser: null,
                lastNameUser: null,
                emailUser: null,
                modalPhone: true,
                tapeCodesignup: false,
                modalSignup: false,
                tapeCode:false,
                auth: null,
                code: "",
                inputCode: {
                    securityCodeLength: 4,
                },
                inputCodeSignup: {
                    securityCodeLength: 4,
                },
                langs: {
                    'fr': 'Français',
                    'nl': 'Dutch',
                    'en': 'English'
                },
                bookings: null,
                bookingName: "",
                attenderName: "",
                phoneNumber: "",
                phoneNumberSignup: "",
                bindProps: {
                    mode: "international",
                    defaultCountry: this.$i18n.locale,
                    disabledFetchingCountry: false,
                    disabled: false,
                    disabledFormatting: false,
                    placeholder: '',
                    required: false,
                    enabledCountryCode: false,
                    enabledFlags: true,
                    preferredCountries: ["BE", "FR", "GB", "SN", "IT", "ES", 'CI'],
                    onlyCountries: [],
                    ignoredCountries: [],
                    autocomplete: "off",
                    name: "telephone",
                    maxLen: 25,
                    wrapperClasses: "",
                    inputClasses: "",
                    dropdownOptions: {
                        disabledDialCode: false
                    },
                    inputOptions: {
                        showDialCode: false
                    }
                },
                date: new Date(),
                configdateTimePicker: {
                    firstDayOfWeek: 1,
                    locale: this.$i18n.locale,
                    enableTime: false,
                    dateFormat: 'd/m/Y',
                    allowInput: false,
                    use24hours: true,
                    inline: false,
                    minDate: new Date(),
                    top: true,
                },
                slotDurations: [],
                slotDurationsCredits: [],
                showAll: false,
                priceSelected: 50,
                modalConnexion: false,
                user: null,
                sports: [],
                options: [],
                optionsSelected: [],
                sportSelected: null,
                slotSelected: null,
                selectedDurationM: null,
                domaineSlug: null,
                playgrounds: null,
                isLoading: false,
                fullPage: true,
                clubId: null,
                selectedActivitySlot: null,
            }
        },
        components: {
            Icon,
            BaseCheckbox,
            'b-modal': BModal,
            'b-card': BCard,
            'b-dropdown': BDropdown,
            'b-dropdown-item': BDropdownItem,
            'b-col' : BCol,
            'b-form-input': BFormInput,
            'b-form-select': BFormSelect,
            flatPickr,
            UserIcon,
            Sms,
            Loading,
            FormActivity
        },
        directives: {
            'b-modal': VBModal
        },
        created() {

            if (this.$route.query.lang != undefined) {
                this.$i18n.locale = this.$route.query.lang;
                this.bindProps.defaultCountry =  this.$route.query.lang;
                this.configdateTimePicker.locale = this.$i18n.locale;
            }

            if (this.$i18n.locale == 'nl') {
                this.configdateTimePicker.locale = "nl";
            }

            this.isLoading = true;
            this.getUser(null);
            let currentUrl = window.location.hostname;
            this.domaineSlug = currentUrl.split(".")[0];
            this.changeStyle();

            if (this.domaineSlug == 'circusmons' || this.domaineSlug == 'niklaas' || this.domaineSlug == 'gent' ) {
              this.bindProps.defaultCountry =  "be";
            }

            if (this.domaineSlug == 'agora' ) {
              this.bindProps.defaultCountry =  "ci";
              this.devise = 'F CFA';
            }

            clubService.getPlaygrounds(moment(this.date).format("DD-MM-Y"), this.domaineSlug)
                .then(response => {
                    this.playgrounds = response.playgrounds;
                    this.sports = response.sports;
                    this.clubId = response.clubId;
                    if (response.style !== null) {
                        this.brandedApp = response.style;
                    }
                    let keys = Object.keys(this.sports);
                    if (keys <= 1) {
                        this.sports = null;
                    }

                    this.showAll = false;
                    this.isLoading = false;
                    this.getCreditUserClub();
                })
                .catch(err => {
                    console.log("Error : "+err);
                    this.isLoading = false;
                });

        },
        mounted() {
            if (this.domaineSlug == 'lamaisondusquash' ) {
                this.limitRow = 100;
            }
        },
        methods: {

            changeStyle() {
                let darkThemeLinkEl = document.createElement("link");
                darkThemeLinkEl.setAttribute("rel", "stylesheet");
                darkThemeLinkEl.setAttribute("href", "/assets/mb_css/"+this.domaineSlug+".css");
                darkThemeLinkEl.setAttribute("id", "dark-theme-style");

                let docHead = document.querySelector("head");
                docHead.append(darkThemeLinkEl);
            },


            checkCreditAvailable() {
                let typeHour = this.slotSelected.type;
                let content = '';
                let valeur = 0;

                this.myCredits.forEach((element, index) => {
                    console.log(element);
                    if (typeHour == 'happyhourPrice') {
                        content = 'creuse';
                    } else if (typeHour == 'normalPrice' ) {
                        content = 'pleine';
                    }

                    if (element.libelle.includes(content)) {
                        valeur += element.value;
                        this.typeCredit = index;
                    }
                });

                return valeur;
            },
            getCreditUserClub() {

                userService.userMe(null)
                    .then(resp => {
                        this.user = resp;
                        userService.getCredits(this.user.id , this.clubId).then(resp => {
                            this.myCredits = [];
                            this.myAbonnement = resp.abonnement;
                            this.isBookingFree = resp.servicesOffered;
                            console.log(resp);
                            Object.entries(resp.credit).forEach(element => {
                                console.log(element);
                                if (this.myCredits[element[1].typeId] == undefined) {
                                    this.myCredits[element[1].typeId] = [];
                                    this.myCredits[element[1].typeId]['value'] = element[1].value;
                                    this.myCredits[element[1].typeId]['libelle'] = element[1].type;
                                } else {
                                    this.myCredits[element[1].typeId]['value'] += element[1].value;
                                }

                            });

                            console.log("my credits : ", this.myCredits);
                            this.abonnement = resp.abonnement;
                            this.isLoading = false;
                        }).catch(err => {
                            console.log("ERROR GET CREDITS : ", err)
                        });
                    })
                    .catch(error => {
                        console.log("Error : "+error);
                    });

            },
            inArray: function(needle, haystack) {
                var length = haystack.length;
                for(var i = 0; i < length; i++) {
                    if(haystack[i] == needle) return true;
                }
                return false;
            },
            inArrayDuration: function (needle, haystack) {
                let haystackArray = Object.keys(haystack);
                var length = haystackArray.length;
                for(var i = 0; i < length; i++) {
                    if(haystackArray[i] == needle) return true;
                }
                return false;
            },
            myLocalSetterFunction(lang) {
                $i18n.locale = lang;
            },
            createAccount() {
                let appName = "doinsport";
                if (this.domaineSlug === "circusmons" || this.domaineSlug === "gent" || this.domaineSlug === "niklaas" ) {
                    appName = "Circus Arena";
                } else if (this.domaineSlug === "msquash") {
                    appName = "msquash";
                }

                let phoneClean = this.phoneNumberSignup;
                phoneClean = phoneClean.split(' ').join("");
                let data = {
                    "firstName": this.firstNameUser,
                    "lastName": this.lastNameUser,
                    "email": this.emailUser,
                    "phoneNumber": phoneClean,
                    "plainPassword": this.inputCodeSignup+"/"+this.emailUser,
                    "app_name": appName
                };

                userService.register(data)
                    .then(resp => {
                        if (resp[0] === "success") {
                            let respToken = resp[1].token;
                            localStorage.setItem('token', respToken);
                            this.getUser();
                            this.modalConnexion = false;
                            this.$toastr.Add({
                                name: "successConnexion",
                                msg: this.$t('your_connected'),
                                type: "success"
                            });
                            this.phoneNumber = "";
                            this.phoneNumberSignup = "";
                            this.code = null;
                            this.tapeCode = false;

                            this.modalConnexion = false;
                            this.modalSignup = false;
                            this.modalSignupStep1 = false;
                            this.modalSignupStep2 = false;
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });

                this.modalSignupStep1 = false;
                this.modalSignupStep2 = true;
            },
            createNewAccount() {
                this.isLoading = true;
                userService.checkPhone(this.phoneNumberSignup, {}, false, this.domaineSlug, this.$i18n.locale)
                    .then(resp => {
                        if (resp.success) {

                            this.$toastr.Add({
                                name: "SuccessSms",
                                msg: this.$t('sms_sended'),
                                type: "success"
                            });

                            this.auth = resp;
                            this.tapeCodesignup = true;
                        } else {
                            this.$toastr.Add({
                                name: "ErrorSMS",
                                msg: this.$t('user_already_exist'),
                                type: "warning"
                            });
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });

            },
            moment,
            emitOnChange(selectedDates, dateStr, instance) {
                this.isLoading = true;
                clubService.getPlaygrounds(dateStr.replace('/', '-').replace('/', '-'), this.domaineSlug)
                    .then(response => {
                        this.playgrounds = response.playgrounds;
                        this.sports = response.sports;
                        this.clubId = response.clubId;

                        let keys = Object.keys(this.sports);

                        if (keys <= 1) {
                            this.sports = null;
                        }

                        this.showAll = false;
                        this.isLoading = false;
                    })
                    .catch(err => {
                        console.log("Error : "+err);
                        this.isLoading = false;
                    });
            },
            showAllAction() {
                this.showAll = true;
            },
            logout() {
                this.user = null;
                localStorage.removeItem("userInfo");
                localStorage.removeItem("token");
                this.myCredits = [];
                this.typeCredit = null;
            },
            cancelConnexion () {
                this.modalSignup = false;
                this.modalSignupStep1 = true;
                this.modalSignupStep2 = false;
                this.modalConnexion = false;
                this.tapeCode = false;
                this.phoneNumber = "";
                this.phoneNumberSignup = "";
                this.code = "";
                //this.inputCodeSignup = "";
            },
            updatePriceOption (optionselected) {

                var priceDefault = this.slotDurations[this.selectedDurationM];
                var price = 0;
                let isFix = false;

                this.optionsSelected.forEach(element => {
                    this.options.forEach(option => {
                        if (element == option.id) {

                            if (option.fix == true) {
                                priceDefault = 0;
                                price = option.price;
                                isFix = true;
                            } else {
                                price = price + option.price;
                            }
                            if (option.duration != 0) {
                                this.selectedDurationM = option.duration;
                            }
                        }
                    });
                });
                if (isFix) {
                    this.priceSelected = price;
                    this.selectReadonly = true;
                } else {
                    this.priceSelected = priceDefault + price;
                    this.selectReadonly = false;
                }

                this.updateEndSlot(isFix);
            },
            showInfo(text){
                this.$toastr.Add({
                    name: "infoPriceOption",
                    msg: text,
                    type: "success"
                });
            },
            connexion () {
                this.isLoading = true;
                userService.login(this.phoneNumber, {}, false, this.domaineSlug, this.$i18n.locale)
                    .then(resp => {
                        if (resp.success) {

                            this.$toastr.Add({
                                name: "SuccessSms",
                                msg: this.$t('sms_sended'),
                                type: "success"
                            });

                            this.auth = resp;
                            this.tapeCode = true;
                        } else {
                            this.$toastr.Add({
                                name: "ErrorSMS",
                                msg: this.$t('no_account'),
                                type: "warning"
                            });
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                    });

            },
            validCodeSmsSignUp() {
                let phoneNumber = this.phoneNumberSignup.split(' ').join('');
                this.isLoading = true;
                var hashMd5 = md5.hex(phoneNumber) + "/" + this.code;
                let completHash = sha1(hashMd5);

                if (completHash === this.auth.tokenConfirmation) {
                    this.modalSignupStep1 = false;
                    this.modalSignupStep2 = true;

                } else {

                    this.$toastr.Add({
                        name: "errorConnexion",
                        msg: this.$t('bad_code'),
                        type: "error"
                    });

                }

                this.isLoading = false;
            },
            validCodeSms() {
                let phoneNumber = this.phoneNumber.split(' ').join('');
                this.isLoading = true;
                var hashMd5 = md5.hex(phoneNumber) + "/" + this.code;
                let completHash = sha1(hashMd5);

                if (completHash === this.auth.tokenConfirmation) {

                    localStorage.setItem('token', this.auth.auth.token);
                    this.getUser();

                    this.modalConnexion = false;
                    this.$toastr.Add({
                        name: "successConnexion",
                        msg: this.$t('your_connected'),
                        type: "success"
                    });

                    this.phoneNumber = "";
                    this.code = null;
                    this.tapeCode = false;

                    this.getCreditUserClub();
                } else {

                    this.$toastr.Add({
                        name: "errorConnexion",
                        msg: this.$t('bad_code'),
                        type: "error"
                    });

                }
                this.isLoading = false;
            },
            getUser() {
                userService.userMe(null)
                    .then(resp => {
                        this.user = resp;
                        this.getBookings();
                    })
                    .catch(error => {
                        console.log("Error : "+error);
                    });
            },
            getBookings() {
                bookingService.myBookings(this.user)
                    .then(resp => {
                        this.bookings = resp.data.bookings.edges;
                    })
                    .catch(error => {
                        console.log("Error : "+error);
                    });

                bookingService.myActivitys(this.user)
                    .then(resp => {
                        console.log('activities ====> ', resp.data.bookings.edges);
                    })
                    .catch(error => {
                        console.log("Error : "+error);
                    });
            },
            confirmBooking (credit = false) {

                this.isLoading = true;
                let optionsBooking = [];
                this.optionsSelected.forEach(element => {
                    optionsBooking.push("/api/service_optionnals/"+element);
                });

                let truncate = this.slotSelected.endTime.split(" ");
                let endTime = truncate[1];

                if (endTime === '00:00' || endTime === '0:00' || endTime === '00:00:00' || endTime === '0:00:00') {
                    let momentEndDate = moment(this.slotSelected.endTime);
                    momentEndDate = moment(momentEndDate).subtract(1, "seconds").toDate();
                    this.slotSelected.endTime = moment(momentEndDate).format("Y-MM-DD H:mm:ss");
                }

                if (this.domaineSlug === "lamaisondusquash") {
                    this.bookingName = '-';
                }

                let data = {
                    price: this.priceSelected,
                    useCredit: credit,
                    creditType: parseInt(this.typeCredit),
                    creditValue: this.slotDurationsCredits[this.selectedDurationM],
                    name: this.bookingName,
                    comment: this.attenderName,
                    playground: {id: this.slotSelected.playgroundId},
                    club: {id: this.clubId},
                    fromClub: this.slotSelected.startTime,
                    toClub: this.slotSelected.endTime,
                    options: optionsBooking,
                    platform: 'WEB'
                };

                bookingService.addBooking(data)
                    .then(resp => {

                        this.slotSelected = null;
                        this.bookingName = null;
                        this.isLoading = false;

                        if (this.domaineSlug === "lamaisondusquash") {
                            this.bookingName = '-';
                        }

                        this.$toastr.Add({
                            name: "SuccessBooking", // this is give you ability to use removeByName method
                            msg: this.$t('confirm_booking'), // Toast Message
                            type: "success" // Toast type,
                        });
                        this.getBookings();

                        clubService.getPlaygrounds(moment(this.date).format("DD-MM-Y"), this.domaineSlug)
                            .then(response => {
                                this.playgrounds = response.playgrounds;
                                this.sports = response.sports;
                                this.clubId = response.clubId;
                                if (response.style !== null) {
                                    this.brandedApp = response.style;
                                }
                                let keys = Object.keys(this.sports);
                                if (keys <= 1) {
                                    this.sports = null;
                                }

                                this.showAll = false;
                                this.isLoading = false;
                                this.getCreditUserClub();
                            })
                            .catch(err => {
                                console.log("Error : "+err);
                                this.isLoading = false;
                            });

                    })
                    .catch(err => {
                        this.$toastr.Add({
                            name: "ErrorBooking", // this is give you ability to use removeByName method
                            msg: this.$t('failed_booking'), // Toast Message
                            type: "error" // Toast type,
                        });
                        this.isLoading = false;
                    });
            },
            getCreditByDuration() {

                return this.slotDurationsCredits[this.selectedDurationM];
            },
            cancelBooking(id) {
                bookingService.cancelBooking(id)
                    .then(resp => {
                        this.getBookings();
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            openConnexion () {

                this.modalConnexion = true;
            },
            updateSport(id) {
                this.sportSelected = id;
            },
            cancelSlot () {
                this.slotSelected = null;
            },
            selectSlot (playgroundId, slotId) {
                this.options = [];

                if (this.user != null) {

                    bookingService.getOptions(playgroundId)
                        .then(resp => {
                            this.options = resp;
                        })
                        .catch(error => {

                        });

                    let slot = this.playgrounds[playgroundId].data.slots[slotId];
                    bookingService.getDuration(playgroundId, slot.startTime)
                        .then(resp => {
                            this.slotDurations = resp.prices;
                            this.slotDurationsCredits = resp.credits;
                            this.slotSelected = slot;
                            this.slotSelected['playgroundName'] = this.playgrounds[playgroundId].playground_name;
                            this.slotSelected['playgroundId'] = playgroundId;
                            let start = moment(slot.startTime);
                            let end = moment(slot.endTime);
                            let diff = end.diff(start, "minutes");
                            this.selectedDurationM = diff;
                            this.priceSelected = this.slotDurations[diff];
                            if (this.priceSelected == undefined) {
                                this.selectedDurationM = 60;
                                this.updateEndSlot();
                            }
                            if (this.user === null) {
                                this.modalConnexion = true;
                            }
                        })
                        .catch(error => {

                        });
                } else {
                    this.modalConnexion = true;
                }

            },
            updateEndSlot (isFix = false) {
                var next = moment(this.slotSelected.startTime);
                next.add(this.selectedDurationM, "minutes");
                this.slotSelected.endTime = next.format("Y-MM-DD H:mm:ss");

                if (isFix == false) {
                    var priceDefault = this.slotDurations[this.selectedDurationM];
                    var price = 0;
                    this.optionsSelected.forEach(element => {
                        this.options.forEach(option => {
                            if (element == option.id) {
                                price = price + option.price;
                            }
                        });
                    });

                    this.priceSelected = priceDefault + price;
                }
            },
            getFormActivitySlot(playgroundId, slot) {
                if (slot.available < 1) {
                    // todo : alert not available
                    return false;
                }
                const self = this;
                playgroundService.getFormActivity(playgroundId).then(resp => {
                    console.log("test ok : ", resp);
                    self.formActivity = resp;
                    self.selectedActivitySlot = slot;
                    self.selectedActivitySlot['playgroundId'] = playgroundId;
                    self.showActivityForm = true;
                    console.log("test ok END ");
                });

            }
        }
    }
</script>

<style lang="scss">


    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        margin-top: 10px;
        color: #e12326;
        .logo-img {
            border-radius: 50%;
        }
        .nav-bar {
            text-align: right;
            padding-right: 100px;
        }

        .btn-booking {
            display: none;
            border: none;
        }
        .btn-slot {
            border: none;
        }
        .phone-input {
            border: none!important;
            font-size: 25px!important;
            border-bottom: 1px solid!important;
        }

        .sport-choices {
            display: inline-block;
            button {
                background-color: white;
                font-size: 30px;
                border-radius: 10px;
                box-shadow: 0px 0px 5px cornflowerblue;
                margin: 30px;
                text-decoration: none;
                color: cornflowerblue;
                padding-top: 10px;
                padding-bottom: 10px;
            }
            button.sportSelected {
                background-color: cornflowerblue;
                border: 1px solid cornflowerblue;
                color: white;
            }

            button.sportSelected:focus {
                border: none;
            }
        }

        .playground-choices {
            margin-top: 20px;
            display: inline-block;
            width: 100%;
            .btn-slot {
                display: block;
                width: 100%;
                font-size: 30px;
                margin-bottom: 10px;
                background: cornflowerblue;
                color: white;
                font-weight: 800;
                border-radius: 15px;
            }
            .btn-slot:hover {
                background: white;
                color: cornflowerblue;
                font-weight: 800;
            }
        }

        .sport-choices:hover {

        }

        .flatpickr-input {
            border: none;
            font-size: 30px;
            box-shadow: 0px 0px 5px cornflowerblue;
            text-align: center;
        }

        .playground {
            width: 200px;
            display: inline-block;
            padding: 10px;
            margin: 5px;
            vertical-align: top;
            h3 {
                min-height: 90px;
            }
        }

        .showallBooking {
            width: 100%;
            max-width: 300px;
            font-size: 20px;
            display: block;
            text-align: center;
            margin: auto;
        }

        .showallBooking:hover {
            background: coral;
            color: white;
        }

        .block {
            display: block;
        }
        .text-right {
            text-align: right;
        }
        .text-left {
            text-align: left;
        }
        h2.text-left {
            margin: 10px;
        }

        .block-center {
            position: fixed;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            background-color: rgba(0,0,0,0.3);
            text-align: center;
            z-index: 1;
        }

        .block.end {
            position: absolute;
            bottom: 10px;
            width: 100%;
            text-align: center;
        }

        .btn-booking {
            border-radius: 5%;
            background-color: #d9d9d9;
        }

        .modalblock {
            overflow: scroll;
            position: relative;
            top: 20px;
            margin: auto;
            width: 100%;
            max-width: 600px;
            height: 500px;
            max-height: 90%;
            background-color: white;
            color: cornflowerblue;
            box-shadow: 0px 0px 15px black;
            border-radius: 10px;
            padding: 15px;

            h1, h2 {
                font-size: 30px;
                font-weight: 800;
                color: cornflowerblue;
            }

            .selectDuration {
                width: 100%;
                font-size: 25px;
                background-color: rgba(0,0,0,0);
                color: cornflowerblue;
                margin-top: 20px;
                text-align: center;
            }

            .name-booking {
                width: 100%;
                border: none;
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                text-align: center;
                font-size: 30px;
                color: black;
                margin-bottom: 30px;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: coral;
                border-radius: 10px;
                font-size: 25px;
                min-width: 200px;
                padding: 5px;
                color: white;
                border: coral;
                margin-right: 5px;
            }

            button.confirm-credit {
                background-color: cornflowerblue;
                border-radius: 10px;
                font-size: 25px;
                min-width: 200px;
                padding: 5px;
                color: white;
                border: cornflowerblue;
                margin-right: 5px;
            }

            button.confirm {
                background-color: limegreen;
                border-radius: 10px;
                font-size: 25px;
                min-width: 200px;
                padding: 5px;
                color: white;
                border: limegreen;
            }
        }
        .container-planning {
            width: auto;
            margin-right: auto;
            margin-left: auto;
            padding-bottom: 50px;
            max-width: 1000px;
            padding-right: 5px;
            padding-left: 5px;
        }
        .btn-create {
            display: block;
            width: 100%;
            font-size: 20px;
            margin-bottom: 5px;
            color: cornflowerblue;
            font-weight: 500;
            border: none;
        }
        .btn-create:hover {
            font-weight: 800;
        }

        h1, h2 {
            font-weight: 900;
        }
        h1 {
            font-size: 2rem!important;
        }
        h3 {
            font-size: 25px;
        }
        ul {
            list-style-type: none;
            padding: 0;
        }
        li {
            display: inline-block;
            margin: 0 10px;
        }
        a {
            color: #42b983;
        }
        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
            width: 70px!important;
            height: 70px!important;
            font-size: 30px;
        }
        .ofcold__security-code-field {
            width: 70px!important;
        }
        .ofcold__security-code-field:nth-child(3) {
            margin-right: 10px!important;
        }
        label {
            font-size: 1.3rem!important;
            text-align: left;
            width: 100%;
            margin-top: 10px;
            display: block;
            font-weight: 800;
        }
        .btn-user {
            height: 100%;
            width: 100%;
            border: none;
            background-color: transparent;
        }
        .inline {
            display: inline-block!important;
            height: 100%;
            width:auto;
        }

        @media (max-width: 830px) {
            .text-left {
                text-align: center!important;
            }
        }

        .langueSelect button{
            background-color: transparent;
            border: none;
            color: #2b2b58;
        }
        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            border: none;
            color: #2b2b58;
        }
        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: #e12326!important;
            color: white!important;
            font-weight: 900!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }
    }

    #app.lamaisondusquash {

        --green-color: #83c54d;
        --yellow-color: #f9c714;
        --pink-color: #eb689b;
        --blue-color: #5493ce;
        --blue2-color: #00bad3;
        --orange-color: #f68c1f;

        color: var(--blue-color);

        .sport-choices {
            button {
                background-color: white;
                box-shadow: 0px 0px 5px var(--blue-color);
                color: var(--blue-color);
            }
            button.sportSelected {
                background-color: var(--blue-color);
                border: 1px solid var(--blue-color);
                color: white;
            }
        }

        .badge-hp, .badge-hc {
            border-radius: 20px;
            color: white;
            font-size: 14px;
            padding:  3px 8px 3px 8px;
        }
        .badge-hp {
            background-color: rgba(246, 140, 31, 0.7) !important;
        }
        .badge-hc {
            background-color: rgba(123, 194, 66, 0.7) !important;
        }

        .btn-booking {
            display: block;
            width: 100%;
            font-size: 16px;
            margin-bottom: 10px;
            background: indianred;
            color: white;
            font-weight: 800;
            border-radius: 15px;
        }

        .playground-choices {
            overflow-x: scroll;
            display: inline-flex;
            .btn-slot {
                background: rgba(246, 140, 31, 0.7)!important;
                color: white;
                font-size: 14px;
            }
            .btn-slot:hover {
                background: rgba(246, 140, 31, 1)!important;
                color: white;
            }
            .btn-slot.happyhourPrice {
                background: rgba(123, 194, 66, 0.7)!important;
            }
            .btn-slot.happyhourPrice:hover {
                background: rgba(123, 194, 66, 1)!important;
            }
        }

        .flatpickr-input {
            box-shadow: 0px 0px 5px var(--blue-color);
        }

        .showallBooking:hover {
            background: var(--pink-color);
            color: white;
        }

        .block-center {
            background-color: rgba(0,0,0,0.3);
        }


        .modalblock {
            background-color: white;
            color: var(--blue-color);
            h1, h2 {
                color: var(--blue-color);
            }

            .selectDuration {
                background-color: rgba(0,0,0,0);
                color: var(--blue-color);
            }

            .name-booking {
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                color: black;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: var(--pink-color);
                color: white;
                border: var(--pink-color);
            }

            button.confirm-credit {
                background-color: var(--blue-color);
                color: white;
                border: var(--pink-color);
            }
            button.confirm {
                background-color: limegreen;
                color: white;
                border: limegreen;
            }
        }

        .btn-create {
            color: var(--blue-color);
        }

        a {
            color: #42b983;
        }

        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
        }

        .btn-user {
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button{
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            color: var(--orange-color);
        }

        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: var(--blue2-color)!important;
            color: white!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }

        .playground {
            width: 200px;
            display: table-cell;
            padding: 0;
            margin: 0;
            vertical-align: top;
            h3 {
                padding-top: 10px;
                min-height: 60px;
                background-color: var(--pink-color);
                border-right: 2px solid white;
                border-radius: 5px;
                color: white;
            }
        }
        .container-planning {
            max-width: 80%;
        }
    }

    #app.player63 {

        --green-color: #ec392c;
        --yellow-color: #f9c714;
        --pink-color: #212331;
        --blue-color: #ec392c;
        --blue2-color: #212331;
        --orange-color: #ec392c;

        color: var(--blue-color);

        .sport-choices {
            button {
                background-color: white;
                box-shadow: 0px 0px 5px var(--blue-color);
                color: var(--blue-color);
            }
            button.sportSelected {
                background-color: var(--blue-color);
                border: 1px solid var(--blue-color);
                color: white;
            }
        }

        .playground-choices {
            overflow-x: scroll;
            display: table;
            .btn-slot {
                background: rgba(246, 140, 31, 0.7)!important;
                color: white;
                font-size: 14px;
            }
            .btn-slot:hover {
                background: rgba(246, 140, 31, 1)!important;
                color: white;
            }
            .btn-slot.happyhourPrice {
                background: rgba(123, 194, 66, 0.7)!important;
            }
            .btn-slot.happyhourPrice:hover {
                background: rgba(123, 194, 66, 1)!important;
            }
        }

        .flatpickr-input {
            box-shadow: 0px 0px 5px var(--blue-color);
        }

        .showallBooking:hover {
            background: var(--pink-color);
            color: white;
        }

        .block-center {
            background-color: rgba(0,0,0,0.3);
        }


        .modalblock {
            background-color: white;
            color: var(--blue-color);
            h1, h2 {
                color: var(--blue-color);
            }

            .selectDuration {
                background-color: rgba(0,0,0,0);
                color: var(--blue-color);
            }

            .name-booking {
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                color: black;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: var(--pink-color);
                color: white;
                border: var(--pink-color);
            }
            button.confirm {
                background-color: limegreen;
                color: white;
                border: limegreen;
            }
        }

        .btn-create {
            color: var(--blue-color);
        }

        a {
            color: #42b983;
        }

        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
        }

        .btn-user {
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button{
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            color: var(--orange-color);
        }

        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: var(--blue2-color)!important;
            color: white!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }

        .playground {
            width: 200px;
            display: table-cell;
            padding: 0;
            margin: 0;
            vertical-align: top;
            h3 {
                padding-top: 10px;
                min-height: 60px;
                background-color: var(--pink-color);
                border-right: 2px solid white;
                border-radius: 5px;
                color: white;
            }
        }
        .container-planning {
            max-width: 80%;
        }
    }

    #app.mksoccer {

        --green-color: #374186;
        --yellow-color: #1d1a1b;
        --pink-color: #374186;
        --blue-color: #374186;
        --blue2-color: #374186;
        --orange-color: #1d1a1b;

        color: var(--blue-color);

        .sport-choices {
            button {
                background-color: white;
                box-shadow: 0px 0px 5px var(--blue-color);
                color: var(--blue-color);
            }
            button.sportSelected {
                background-color: var(--blue-color);
                border: 1px solid var(--blue-color);
                color: white;
            }
        }

        .playground-choices {
            overflow-x: scroll;
            display: table;
            .btn-slot {
                background: rgba(246, 140, 31, 0.7)!important;
                color: white;
                font-size: 14px;
            }
            .btn-slot:hover {
                background: rgba(246, 140, 31, 1)!important;
                color: white;
            }
            .btn-slot.happyhourPrice {
                background: rgba(123, 194, 66, 0.7)!important;
            }
            .btn-slot.happyhourPrice:hover {
                background: rgba(123, 194, 66, 1)!important;
            }
        }

        .flatpickr-input {
            box-shadow: 0px 0px 5px var(--blue-color);
        }

        .showallBooking:hover {
            background: var(--pink-color);
            color: white;
        }

        .block-center {
            background-color: rgba(0,0,0,0.3);
        }


        .modalblock {
            background-color: white;
            color: var(--blue-color);
            h1, h2 {
                color: var(--blue-color);
            }

            .selectDuration {
                background-color: rgba(0,0,0,0);
                color: var(--blue-color);
            }

            .name-booking {
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                color: black;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: var(--pink-color);
                color: white;
                border: var(--pink-color);
            }
            button.confirm {
                background-color: limegreen;
                color: white;
                border: limegreen;
            }
        }

        .btn-create {
            color: var(--blue-color);
        }

        a {
            color: #42b983;
        }

        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
        }

        .btn-user {
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button{
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            color: var(--orange-color);
        }

        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: var(--blue2-color)!important;
            color: white!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }

        .playground {
            width: 200px;
            display: table-cell;
            padding: 0;
            margin: 0;
            vertical-align: top;
            h3 {
                padding-top: 10px;
                min-height: 60px;
                background-color: var(--pink-color);
                border-right: 2px solid white;
                border-radius: 5px;
                color: white;
            }
        }
        .container-planning {
            max-width: 80%;
        }
    }

    #app.montfoot5 {

        --green-color: #dd644a;
        --yellow-color: #000000;
        --pink-color: #dd644a;
        --blue-color: #dd644a;
        --blue2-color: #dd644a;
        --orange-color: #000000;

        color: var(--blue-color);

        .sport-choices {
            button {
                background-color: white;
                box-shadow: 0px 0px 5px var(--blue-color);
                color: var(--blue-color);
            }
            button.sportSelected {
                background-color: var(--blue-color);
                border: 1px solid var(--blue-color);
                color: white;
            }
        }

        .playground-choices {
            overflow-x: scroll;
            display: table;
            .btn-slot {
                background: rgba(246, 140, 31, 0.7)!important;
                color: white;
                font-size: 14px;
            }
            .btn-slot:hover {
                background: rgba(246, 140, 31, 1)!important;
                color: white;
            }
            .btn-slot.happyhourPrice {
                background: rgba(123, 194, 66, 0.7)!important;
            }
            .btn-slot.happyhourPrice:hover {
                background: rgba(123, 194, 66, 1)!important;
            }
        }

        .flatpickr-input {
            box-shadow: 0px 0px 5px var(--blue-color);
        }

        .showallBooking:hover {
            background: var(--pink-color);
            color: white;
        }

        .block-center {
            background-color: rgba(0,0,0,0.3);
        }


        .modalblock {
            background-color: white;
            color: var(--blue-color);
            h1, h2 {
                color: var(--blue-color);
            }

            .selectDuration {
                background-color: rgba(0,0,0,0);
                color: var(--blue-color);
            }

            .name-booking {
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                color: black;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: var(--pink-color);
                color: white;
                border: var(--pink-color);
            }
            button.confirm {
                background-color: limegreen;
                color: white;
                border: limegreen;
            }
        }

        .btn-create {
            color: var(--blue-color);
        }

        a {
            color: #42b983;
        }

        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
        }

        .btn-user {
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button{
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            color: var(--orange-color);
        }

        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: var(--blue2-color)!important;
            color: white!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }

        .playground {
            width: 200px;
            display: table-cell;
            padding: 0;
            margin: 0;
            vertical-align: top;
            h3 {
                padding-top: 10px;
                min-height: 60px;
                background-color: var(--pink-color);
                border-right: 2px solid white;
                border-radius: 5px;
                color: white;
            }
        }
        .container-planning {
            max-width: 80%;
        }

        .btn-booking {
            display: none;
        }
    }

    #app.allinacademy {

        --green-color: #000000;
        --yellow-color: #000000;
        --pink-color: #000000;
        --blue-color: #000000;
        --blue2-color: #000000;
        --orange-color: #000000;

        color: var(--blue-color);

        .sport-choices {
            button {
                background-color: white;
                box-shadow: 0px 0px 5px var(--blue-color);
                color: var(--blue-color);
            }
            button.sportSelected {
                background-color: var(--blue-color);
                border: 1px solid var(--blue-color);
                color: white;
            }
        }

        .playground-choices {
            overflow-x: scroll;
            display: table;
            .btn-slot {
                background: rgba(246, 140, 31, 0.7)!important;
                color: white;
                font-size: 14px;
            }
            .btn-slot:hover {
                background: rgba(246, 140, 31, 1)!important;
                color: white;
            }
            .btn-slot.happyhourPrice {
                background: rgba(123, 194, 66, 0.7)!important;
            }
            .btn-slot.happyhourPrice:hover {
                background: rgba(123, 194, 66, 1)!important;
            }
        }

        .flatpickr-input {
            box-shadow: 0px 0px 5px var(--blue-color);
        }

        .showallBooking:hover {
            background: var(--pink-color);
            color: white;
        }

        .block-center {
            background-color: rgba(0,0,0,0.3);
        }


        .modalblock {
            background-color: white;
            color: var(--blue-color);
            h1, h2 {
                color: var(--blue-color);
            }

            .selectDuration {
                background-color: rgba(0,0,0,0);
                color: var(--blue-color);
            }

            .name-booking {
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                color: black;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: var(--pink-color);
                color: white;
                border: var(--pink-color);
            }
            button.confirm {
                background-color: limegreen;
                color: white;
                border: limegreen;
            }
        }

        .btn-create {
            color: var(--blue-color);
        }

        a {
            color: #42b983;
        }

        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
        }

        .btn-user {
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button{
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            color: var(--orange-color);
        }

        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: var(--blue2-color)!important;
            color: white!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }

        .playground {
            width: 200px;
            display: table-cell;
            padding: 0;
            margin: 0;
            vertical-align: top;
            h3 {
                padding-top: 10px;
                min-height: 60px;
                background-color: var(--pink-color);
                border-right: 2px solid white;
                border-radius: 5px;
                color: white;
            }
        }
        .container-planning {
            max-width: 80%;
        }

        .btn-booking {
            display: none;
        }
    }

    #app.jeudepaume {

        --green-color: #004b8e;
        --yellow-color: #f0121e;
        --pink-color: #004b8e;
        --blue-color: #004b8e;
        --blue2-color: #004b8e;
        --orange-color: #004b8e;

        color: var(--blue-color);

        .sport-choices {
            button {
                background-color: white;
                box-shadow: 0px 0px 5px var(--blue-color);
                color: var(--blue-color);
            }
            button.sportSelected {
                background-color: var(--blue-color);
                border: 1px solid var(--blue-color);
                color: white;
            }
        }

        .playground-choices {
            overflow-x: scroll;
            display: table;
            .btn-slot {
                background: rgba(246, 140, 31, 0.7)!important;
                color: white;
                font-size: 14px;
            }
            .btn-slot:hover {
                background: rgba(246, 140, 31, 1)!important;
                color: white;
            }
            .btn-slot.happyhourPrice {
                background: rgba(123, 194, 66, 0.7)!important;
            }
            .btn-slot.happyhourPrice:hover {
                background: rgba(123, 194, 66, 1)!important;
            }
        }

        .flatpickr-input {
            box-shadow: 0px 0px 5px var(--blue-color);
        }

        .showallBooking:hover {
            background: var(--pink-color);
            color: white;
        }

        .block-center {
            background-color: rgba(0,0,0,0.3);
        }


        .modalblock {
            background-color: white;
            color: var(--blue-color);
            h1, h2 {
                color: var(--blue-color);
            }

            .selectDuration {
                background-color: rgba(0,0,0,0);
                color: var(--blue-color);
            }

            .name-booking {
                background-color: rgba(0,0,0,0);
                border-bottom: 1px solid gainsboro;
                color: black;
            }

            .name-booking::placeholder {
                color: gainsboro;
            }

            button.cancel {
                background-color: var(--pink-color);
                color: white;
                border: var(--pink-color);
            }
            button.confirm {
                background-color: limegreen;
                color: white;
                border: limegreen;
            }
        }

        .btn-create {
            color: var(--blue-color);
        }

        a {
            color: #42b983;
        }

        .ofcold__security-code-field input {
            background-color: rgba(200,200,200,0.2);
        }

        .btn-user {
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button{
            background-color: transparent;
            color: var(--orange-color);
        }

        .langueSelect button:focus, .langueSelect button:hover {
            background-color: transparent;
            color: var(--orange-color);
        }

        .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
            background-color: var(--blue2-color)!important;
            color: white!important;
        }
        .flatpickr-day.disabled:hover {
            background-color: gainsboro!important;
        }

        .playground {
            width: 200px;
            display: table-cell;
            padding: 0;
            margin: 0;
            vertical-align: top;
            h3 {
                padding-top: 10px;
                min-height: 60px;
                background-color: var(--pink-color);
                border-right: 2px solid white;
                border-radius: 5px;
                color: white;
            }
        }
        .container-planning {
            max-width: 80%;
        }

        .btn-booking {
            display: none;
        }
    }

    #app.arenafoot {

      --green-color: #004b8e;
      --yellow-color: #f0121e;
      --pink-color: #004b8e;
      --blue-color: #004b8e;
      --blue2-color: #004b8e;
      --orange-color: #004b8e;

      color: var(--blue-color);

      .sport-choices {
        button {
          background-color: white;
          box-shadow: 0px 0px 5px var(--blue-color);
          color: var(--blue-color);
        }
        button.sportSelected {
          background-color: var(--blue-color);
          border: 1px solid var(--blue-color);
          color: white;
        }
      }

      .playground-choices {
        overflow-x: scroll;
        display: table;
        width: auto!important;
        display: block!important;
        .playground {
          display: block!important;
          width: auto;
        }
        .btn-slot {
          background: rgba(246, 140, 31, 0.7)!important;
          color: white;
          font-size: 14px;

          margin-right: 5px!important;
          padding: 13px!important;
          display: inline-block!important;
          width: auto;
        }
        .btn-slot:hover {
          background: rgba(246, 140, 31, 1)!important;
          color: white;
        }
        .btn-slot.happyhourPrice {
          background: rgba(123, 194, 66, 0.7)!important;
        }
        .btn-slot.happyhourPrice:hover {
          background: rgba(123, 194, 66, 1)!important;
        }
      }

      .flatpickr-input {
        box-shadow: 0px 0px 5px var(--blue-color);
      }

      .showallBooking:hover {
        background: var(--pink-color);
        color: white;
      }

      .block-center {
        background-color: rgba(0,0,0,0.3);
      }


      .modalblock {
        background-color: white;
        color: var(--blue-color);
        h1, h2 {
          color: var(--blue-color);
        }

        .selectDuration {
          background-color: rgba(0,0,0,0);
          color: var(--blue-color);
        }

        .name-booking {
          background-color: rgba(0,0,0,0);
          border-bottom: 1px solid gainsboro;
          color: black;
        }

        .name-booking::placeholder {
          color: gainsboro;
        }

        button.cancel {
          background-color: var(--pink-color);
          color: white;
          border: var(--pink-color);
        }
        button.confirm {
          background-color: limegreen;
          color: white;
          border: limegreen;
        }
      }

      .btn-create {
        color: var(--blue-color);
      }

      a {
        color: #42b983;
      }

      .ofcold__security-code-field input {
        background-color: rgba(200,200,200,0.2);
      }

      .btn-user {
        background-color: transparent;
        color: var(--orange-color);
      }

      .langueSelect button{
        background-color: transparent;
        color: var(--orange-color);
      }

      .langueSelect button:focus, .langueSelect button:hover {
        background-color: transparent;
        color: var(--orange-color);
      }

      .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background-color: var(--blue2-color)!important;
        color: white!important;
      }
      .flatpickr-day.disabled:hover {
        background-color: gainsboro!important;
      }

      .playground {
        width: 200px;
        display: table-cell;
        padding: 0;
        margin: 0;
        vertical-align: top;
        h3 {
          padding-top: 10px;
          min-height: 60px;
          background-color: var(--pink-color);
          border-right: 2px solid white;
          border-radius: 5px;
          color: white;
        }
      }
      .container-planning {
        max-width: 80%;
      }

      .btn-booking {
        display: none;
      }
    }

    #app.agora {

      --green-color: #f59562;
      --yellow-color: #429d60;
      --pink-color: #4a9c5f;
      --blue-color: #f59562;
      --blue2-color: #4a9c5f;
      --orange-color: #f59562;

      color: var(--blue-color);

      .sport-choices {
        button {
          background-color: white;
          box-shadow: 0px 0px 5px var(--blue-color);
          color: var(--blue-color);
        }
        button.sportSelected {
          background-color: var(--blue-color);
          border: 1px solid var(--blue-color);
          color: white;
        }
      }

      .badge-hp, .badge-hc {
        border-radius: 20px;
        color: white;
        font-size: 14px;
        padding:  3px 8px 3px 8px;
      }
      .badge-hp {
        background-color: rgba(246, 140, 31, 0.7) !important;
      }
      .badge-hc {
        background-color: rgba(123, 194, 66, 0.7) !important;
      }

      .btn-booking {
        display: block;
        width: 100%;
        font-size: 16px;
        margin-bottom: 10px;
        background: indianred;
        color: white;
        font-weight: 800;
        border-radius: 15px;
      }

      .playground-choices {
        overflow-x: scroll;
        display: inline-flex;
        .btn-slot {
          background-color: var(--blue2-color)!important;
          color: white;
          font-size: 14px;
        }
        .btn-slot:hover {
          background: rgba(246, 140, 31, 1)!important;
          color: white;
        }
        .btn-slot.happyhourPrice {
          background: rgba(123, 194, 66, 0.7)!important;
        }
        .btn-slot.happyhourPrice:hover {
          background: rgba(123, 194, 66, 1)!important;
        }
      }

      .flatpickr-input {
        box-shadow: 0px 0px 5px var(--blue-color);
      }

      .showallBooking {
        background-color: var(--green-color)!important;
        color: white;
        border: none;
        border-radius: 5pt;
        margin-top: 10pt;
      }
      .showallBooking:hover {
        background-color: var(--yellow-color)!important;
        color: white;
      }

      .block-center {
        background-color: rgba(0,0,0,0.3);
      }


      .modalblock {
        background-color: white;
        color: var(--blue-color);
        h1, h2 {
          color: var(--blue-color);
        }

        .selectDuration {
          background-color: rgba(0,0,0,0);
          color: var(--blue-color);
        }

        .name-booking {
          background-color: rgba(0,0,0,0);
          border-bottom: 1px solid gainsboro;
          color: black;
        }

        .name-booking::placeholder {
          color: gainsboro;
        }

        button.cancel {
          background-color: var(--pink-color);
          color: white;
          border: var(--pink-color);
        }

        button.confirm-credit {
          background-color: var(--blue-color);
          color: white;
          border: var(--pink-color);
        }
        button.confirm {
          background-color: limegreen;
          color: white;
          border: limegreen;
        }
      }

      .btn-create {
        color: var(--blue-color);
      }

      a {
        color: #42b983;
      }

      .ofcold__security-code-field input {
        background-color: rgba(200,200,200,0.2);
      }

      .btn-user {
        background-color: transparent;
        color: var(--orange-color);
      }

      .langueSelect button{
        background-color: transparent;
        color: var(--orange-color);
      }

      .langueSelect button:focus, .langueSelect button:hover {
        background-color: transparent;
        color: var(--orange-color);
      }

      .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background-color: var(--blue2-color)!important;
        color: white!important;
      }
      .flatpickr-day.disabled:hover {
        background-color: gainsboro!important;
      }

      .playground {
        min-width: 110px;
        width: inherit;
        display: table-cell;
        padding: 0;
        margin: 0;
        vertical-align: top;
        h3 {
          padding-top: 10px;
          min-height: 60px;
          background-color: var(--blue-color);
          border-right: 2px solid white;
          border-radius: 5px;
          color: white;
          overflow: hidden;
          white-space: pre-wrap;
          font-size: 19px;
        }
      }
      .container-planning {
        max-width: 99%;
      }
    }

</style>
